import { Injectable } from "@angular/core";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { ProductType } from "@obg/ngx.core";

import { CommonContentFailPayload, CommonContentParams, CommonContentSuccessPayload } from "./common-content.model";

export const ACTION_PREFIX = "[Common Content]";
export const COMMON_CONTENT_ACTION_TYPE = {
	getCommonContent: `${ACTION_PREFIX} Get Common Content ${SYNC_SUFFIX}`,
	getCommonMainBanners: `${ACTION_PREFIX} Get Common Main Banners ${SYNC_SUFFIX}`,
	getCommonPromotionalBanners: `${ACTION_PREFIX} Get Common Promotional Banners ${SYNC_SUFFIX}`,
	getSponsorshipBanner: `${ACTION_PREFIX} Get Sponsorship Banner ${SYNC_SUFFIX}`,
	getSuccess: `${ACTION_PREFIX} Fetch Success`,
	getFail: `${ACTION_PREFIX} Fetch Fail`,
};

@Injectable({
	providedIn: "root",
})
export class CommonContentAction {
	getCommonContent(payload: CommonContentParams): ActionWithPayload {
		return {
			type: COMMON_CONTENT_ACTION_TYPE.getCommonContent,
			payload,
		};
	}

	getCommonMainBanners(presenceType?: ProductType): ActionWithPayload {
		return {
			type: COMMON_CONTENT_ACTION_TYPE.getCommonMainBanners,
			payload: presenceType,
		};
	}

	getCommonPromotionalBanners(presenceType?: ProductType): ActionWithPayload {
		return {
			type: COMMON_CONTENT_ACTION_TYPE.getCommonPromotionalBanners,
			payload: presenceType,
		};
	}

	getSponsorshipBanner(presenceType?: ProductType): ActionWithPayload {
		return {
			type: COMMON_CONTENT_ACTION_TYPE.getSponsorshipBanner,
			payload: presenceType,
		};
	}

	getSuccess(payload: CommonContentSuccessPayload): ActionWithPayload {
		return {
			type: COMMON_CONTENT_ACTION_TYPE.getSuccess,
			payload,
		};
	}

	getFail(payload: CommonContentFailPayload): ActionWithPayload {
		return {
			type: COMMON_CONTENT_ACTION_TYPE.getFail,
			payload,
		};
	}
}
